var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var cookie = require('react-cookie');
var facebook = require('../../utils/facebook');

var FacebookLikeModal = createReactClass({
    componentDidMount: function(){
        $('#likePopup .close').click(function(){
            this.close('close');
        }.bind(this));

        $('.fb-like-placeholder').append('<div class="fb-like" data-href="' + window.location.origin + '" data-layout="button" data-action="like" data-size="large" data-show-faces="false" data-share="false"></div>');

        facebook.init(function(){
            window.FB.XFBML.parse($('.fb-like-placeholder')[0]);
            window.FB.Event.subscribe('edge.create', function(url, html_element){
                this.close('like');
            }.bind(this));
            window.FB.Event.subscribe('edge.remove', function(url, html_element){
                this.close('unlike');
            }.bind(this));
        }.bind(this));
    },

    close: function(triggerSource){
        if(triggerSource === 'like') {
            cookie.save('doNotDisturb', true, {path: '/', maxAge: 180 * 24 * 60 * 60});
        }else{
            cookie.save('doNotDisturb', true, {path: '/'});
        }

        this.props.close(triggerSource);
    },

    render: function(){
        return (
            <div id="likePopup" className="clearfix">
                <div id="likePopup-overlay"></div>
                <div id="likePopup-content">
                    <div>
                        <div className="logo-wrapper">
                            <div className="logo-placeholder"></div>
                        </div>

                        <div className="cnt-wrapper">
                            <p><strong>Stay up to date on the latest insights &amp; news from the MyGiHealth team!</strong></p>
                            <p><span className="fb-like-placeholder"></span>Like us on Facebook to keep up-to-date</p>
                        </div>
                    </div>
                    <span className="close"><span className="ion-ios-close-empty"></span><span className="show-for-sr">x</span></span>
                </div>
            </div>
        );
    }
});

module.exports = FacebookLikeModal;



// WEBPACK FOOTER //
// ./src/common/routes/components/facebookLikeModal.jsx